(() => {
  const showGuideSection = () => {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target || !target.closest('.jb-guide')) return;
    if (target.matches('details')) target.open = true;
    let parent = target.parentElement?.closest('details');
    while (parent) {
      parent.open = true;
      parent = parent.parentElement?.closest('details');
    }
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  addEventListener('hashchange', showGuideSection);
  showGuideSection();
})();
